import React from 'react';

import Loader from '../Loader';

const classes = {
  default: {
    main: 'bg-indigo-500 text-white',
    hover: 'hover:bg-indigo-600',
  },
  danger: {
    main: 'bg-rose-500 text-white',
    hover: 'hover:bg-rose-600',
  },
  tetriary: {
    main: 'dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 font-normal',
    hover: 'hover:border-slate-300 dark:hover:border-slate-600',
  },
  secondary: {
    main: 'dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-indigo-500 font-normal',
    hover: 'hover:border-slate-300 dark:hover:border-slate-600',
  },
};

/* eslint-disable react/button-has-type */
function Button({
  children,
  type,
  onClick,
  variant = 'default',
  disabled,
  isSubmitting,
  className,
  reference,
  ...props
}) {
  const currentClasses = classes[variant] || classes.default;

  return (
    <button
      ref={reference}
      type={type || 'button'}
      onClick={onClick}
      disabled={disabled || isSubmitting}
      className={`btn w-full ${
        currentClasses.main
      } md:max-w-sm font-bold py-2 px-4 rounded
       ${disabled ? 'opacity-50 pointer-events-none' : currentClasses.hover}
       ${className ?? ''}
       `}
      {...props}
    >
      {isSubmitting ? <Loader /> : children}
    </button>
  );
}

export default Button;
